import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment.prod';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';

/** */
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ValidarToken } from '../validators/valida-datos';
import { Storage } from '@ionic/storage-angular';
/** */
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class WhatsappService {

  urlWhats = environment.urlWhats;
  urlWhatsMasivos = environment.urlWhatsMasivos;
  urlWhatsWs = environment.urlWhatsWs;
  classUser: any;
  apiUrl = `${environment.urlWhats}/registro-sesion/`;
  apiUrlCierre = `${environment.urlWhats}/registro-fin-sesion/`;
  constructor(private http: HttpClient,
    private storage: Storage
  ) {
  }

  reiniciarServ(url) {
    const data = {};
    return this.http.post(url + '/reiniciar.php', data);
  }

  consultarQr(idAdmin) {

  }

  getCanalPrincipal(idAdmin, id, role, token) {
    console.log(idAdmin, id, role, token, "login amdin");
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.urlWhats}/getCanalPrincipal/${idAdmin}/${id}/${role}`, { headers });
  }

  getCanales(idAdmin, id, role, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.urlWhats}/getCanales/${idAdmin}/${id}/${role}`, { headers });
  }

  getInfoUser(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    //?ad_planIt=true
    return this.http.get(`${urlBack}/getUsuario/${idAdmin}/${id}/${role}`, { headers });
  }


  getQr(idAdmin, id, role, token) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${this.urlWhats}/obtenerUrlQr/${idAdmin}/${id}/${role}?ad_planIt=true`, { headers });
    //obtenerUrlQr
  }

  getStatusSesion(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/consultaSesion/${idAdmin}/${id}/${role}`, { headers });
  }

  getHistorialConver(query, id, role, token, paginacion, body, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/reporteChatsConverFechas/${id}/${role}?${query}&paginacion=${paginacion}`,
      body, { headers });
  }

  getHistorialConverOptimo(query, id, role, token, paginacion, body, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/reporteChatsV2/${id}/${role}?${query}&paginacion=${paginacion}`,
      body, { headers });
  }

  getHistorialChatsBot(query, idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/getNumsBot/${idAdmin}/${id}/${role}?${query}&ad_planIt=true`, { headers });
  }

  getReporteEfectividad(query, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/reporteProductividadAgentes/${id}/${role}?${query}&ad_planIt=true`, { headers });
  }

  getChat(query, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`
    ${urlBack}/historialChatIndividual/${query.id_admin}/${query.id_agente}/${query.id_cliente}/${query.conversacion}/${id}/${role}`,
      { headers });
  }

  getChatInCompl(query, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`
    ${urlBack}/historialChatIndividualCompleto/${query.id_admin}/${query.id_cliente}/${query.conversacion}/${id}/${role}`,
      { headers });
  }

  getChatBot(query, fechas, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`
    ${urlBack}/getNumChatsBot/${query.idAdmin}/${query.numero}/${id}/${role}?ad_planIt=true`, { headers });
  }

  update(query, idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`
    ${urlBack}/updateAdmin/${idAdmin}/${id}/${role}?ad_planIt=true`, query, { headers });
  }

  getSucursales(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/sucursales/${idAdmin}/${id}/${role}`, { headers });
  }

  getSucursalesActivas(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/sucursalesActivas/${idAdmin}/${id}/${role}`, { headers });
  }

  getAgentesSucursales(idAdmin, idSucursal) {
    return this.http.get(`${this.urlWhats}/agentesxSucursal/${idAdmin}/${idSucursal}`);
  }

  sendMessage(query, id) {
    return this.http.post(`
    ${this.urlWhatsWs}enviarMensajeAgente/${id}`, query);
  }

  saveKeyNotPush(keys, usuario) {
    return this.http.post(`
    ${this.urlWhats}/saveKeyNot/${usuario}`, keys);
  }

  deletKeyNotPush(keys, usuario) {
    return this.http.delete(`
    ${this.urlWhats}/deleteKeyNot/${usuario}/${keys.keys.auth}/${keys.keys.p256dh}`);
  }

  // api para consultar las campañas

  consultarCampanas(idAdmin) {
    return this.http.get(`${this.urlWhats}/consultarCampanas/${idAdmin}/`);
  }

  // api para consultar las campañas por filtro

  consultarCampanasFiltro(idAdmin, query, urlBack) {
    if (idAdmin == 40) {
      return this.http.get(`${this.urlWhatsMasivos}/consultarCampanas/${idAdmin}?${query}`);
    } else {
      return this.http.get(`${urlBack}/consultarCampanas/${idAdmin}?${query}`);
    }
  }

  // api para consultar las campañas por filtro

  consultarCalifPlantillas(idAdmin, urlAdmin) {
    return this.http.get(`${urlAdmin}consultarPlantillas/`);
  }

  // --- Api para reporte de sesiones-----
  getSesiones(query, idAdmin, id, role, token, body, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    const url = `${urlBack}/reporteSesiones/${idAdmin}/${id}/${role}?ad_planIt=true&${query}`;
    return this.http.post(url, body, { headers });
  }

  // --- Api para reporte de sesiones-----
  getPromedioConver(query, idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.get(`${urlBack}/reporteProducividadAgentes/${idAdmin}/${id}/${role}?ad_planIt=true&${query}`, { headers });
  }

  //consultar busisness id

  consultaBusiness(idAdmin, urlBack) {
    return this.http.get(`${urlBack}/consultarIdBusiness/${idAdmin}/`);
  }

  //Actualizar el masivo por el id
  updateMasioId(idAdmin, idSeguimiento, id, role, token, data, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.put(`${urlBack}/actualizarCampanaIdSeguimiento/${idAdmin}/${idSeguimiento}/${id}/${role}`, data, { headers });
    // return this.http.post(`${this.urlWhats}/consultarCalif/${id}/${role}`,data );
  }

  // ----- Descarga Camaña individual ----
  descargaCamp(idAdmin, idSeguimiento, nombreFile, id, role, token, urlBack) {
    const data = {
      nombre: nombreFile
    }
    const headers = new HttpHeaders()
      .set('rol-token', token);

    if (idAdmin == 40) {
      return this.http.post(`${this.urlWhatsMasivos}/descargaCampania/${idAdmin}/${idSeguimiento}/${id}/${role}`, data, { headers });
    } else {
      return this.http.post(`${urlBack}/descargaCampania/${idAdmin}/${idSeguimiento}/${id}/${role}`, data, { headers });
    }

  }

  // consultar calificacion
  consultarCalifiacion(idAdmin, id, role, token, data, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/consultarCalif/${id}/${role}`, data, { headers });
    // return this.http.post(`${this.urlWhats}/consultarCalif/${id}/${role}`,data );
  }

  reportePlantillas(idadmin, query, id, role, token, body, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${urlBack}/reportePlantillas/${idadmin}/${id}/${role}?${query}`, body, { headers });
  }

  reportePlantillasMasivos(idadmin, query, id, role, token, body) {
    const headers = new HttpHeaders()
      .set('rol-token', token);
    return this.http.post(`${this.urlWhatsMasivos}/reportePlantillas/${idadmin}/${id}/${role}?${query}`, body, { headers });
  }

  plantillasNoContestadas(idAdmin, id, role, token, urlBack) {
    const headers = new HttpHeaders()
      .set('rol-token', token);

    return this.http.get(`${urlBack}/plantillasSinResponder/${idAdmin}/${id}/${role}`, { headers });
  }

  loginWhatsApp(numero, paisCode) {
    return this.http.get(`${this.urlWhats}/loginViaWhatsApp/${numero}/${paisCode}`);
  }

  validCodeWhatsApp(numero, code) {
    return this.http.get(`${this.urlWhats}/validarCodeLogin/${numero}/${code}`);
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    // worksheet['!rows'] = 'A3:K3';
    // console.log('worksheet',worksheet);
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const workbook: XLSX.WorkBook = { Sheets: { Reporte: worksheet }, SheetNames: ['Reporte'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    //const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
  }



  // eslint-disable-next-line @typescript-eslint/member-ordering
  registerSession(idAdmin: number, idUsuario: number, token: string) {
    console.log(idAdmin, idUsuario);
    const url = `${this.apiUrl}${idAdmin}`;
    const body = { idUsuario, autor: idUsuario, jwt_token: token };
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    return this.http.post(url, body, { headers });
  }

  /*
      // eslint-disable-next-line @typescript-eslint/member-ordering
      cierreSesion(idAdmin:number, idUsuario: number) {
        console.log(idAdmin, idUsuario);
        const url = `${this.apiUrl}${idAdmin}`;
        const body = { idUsuario };
        const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        return this.http.put(url, body, { headers });
      }*/

  // eslint-disable-next-line @typescript-eslint/member-ordering
  finishSession(idAdmin: number, idUsuario: any) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = { id: idUsuario };  // El ID viene del localStorage
    const url = `${this.apiUrlCierre}${idAdmin}`;

    return this.http.put(url, body, { headers });
  }
}
